var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundraiserPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.674412 20C1.00068 20 1.28396 19.7654 1.33849 19.4401C1.82473 16.6168 4.57404 11.6894 11.5479 11.4015V15.0238C11.5479 15.2748 11.689 15.5048 11.9134 15.6196C12.1379 15.7344 12.4081 15.7149 12.6134 15.5691L22.7178 8.39218C22.8949 8.26639 23 8.06328 23 7.8469C23 7.63048 22.8949 7.42741 22.7178 7.30167L12.6134 0.124822C12.4081 -0.0210678 12.1378 -0.0405884 11.9134 0.0742565C11.689 0.189101 11.5479 0.419059 11.5479 0.670056V4.34701C7.23709 4.77459 0 7.86874 0 19.3299C0 19.6786 0.268857 19.969 0.61826 19.9977C0.637082 19.9992 0.655814 20 0.674412 20Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundraiserPreviewIcon);
export default __webpack_public_path__ + "static/media/fundraiser-preview-icon.2f40047df7b6d170cecdd23c3ac3b21c.svg";
export { ForwardRef as ReactComponent };